module.exports = __webpack_public_path__ + "aacca5747d640569446670fc1c94da0d.jpg";